import React from "react";
import {
  GestureResponderEvent,
  Text,
  TouchableOpacity,
  TouchableOpacityProps,
} from "react-native";

type Props = Omit<TouchableOpacityProps, "onPress"> & {
  text: string;
  onPress?: (e: GestureResponderEvent) => void;
  textClassName?: string;
};

export const FormLinkButton: React.FC<Props> = ({
  text,
  onPress,
  className = "",
  textClassName = "",
  ...rest
}) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      accessibilityRole="button"
      activeOpacity={0.7}
      className={className}
      {...rest}
    >
      <Text
        className={`text-blue-900 font-bold text-sm ${textClassName}`}
      >
        {text}
      </Text>
    </TouchableOpacity>
  );
};

export default FormLinkButton;
